module.exports = __webpack_public_path__ + "img/nsmb-500x500.bcbb0393.png";